"use strict";
exports.__esModule = true;
exports.reflect = exports.bitcoinPickingStrategy = exports.BitcoinLikeSigHashType = exports.BitcoinLikeFeePolicy = exports.initialBitcoinResourcesValue = void 0;
exports.initialBitcoinResourcesValue = {
    utxos: []
};
exports.BitcoinLikeFeePolicy = Object.freeze({
    PER_BYTE: "PER_BYTE",
    PER_KBYTE: "PER_KBYTE"
});
exports.BitcoinLikeSigHashType = Object.freeze({
    SIGHASH_ALL: 0x01,
    SIGHASH_NONE: 0x02,
    SIGHASH_SINGLE: 0x03,
    SIGHASH_FORKID: 0x40,
    SIGHASH_ANYONECANPAY: 0x80
});
exports.bitcoinPickingStrategy = {
    DEEP_OUTPUTS_FIRST: 0,
    OPTIMIZE_SIZE: 1,
    MERGE_OUTPUTS: 2
};
var reflect = function (declare) {
    declare("BitcoinLikeInput", {
        methods: {
            getPreviousTransaction: {
                returns: "hex"
            },
            getPreviousTxHash: {},
            getValue: {
                returns: "Amount"
            },
            getPreviousOutputIndex: {},
            getSequence: {},
            getDerivationPath: {
                returns: ["DerivationPath"]
            },
            getAddress: {}
        }
    });
    declare("BitcoinLikeOutput", {
        methods: {
            getTransactionHash: {},
            getOutputIndex: {},
            getValue: {
                returns: "Amount"
            },
            getBlockHeight: {},
            getDerivationPath: {
                returns: "DerivationPath"
            },
            getAddress: {},
            isReplaceable: {}
        }
    });
    declare("BitcoinLikeTransaction", {
        methods: {
            getHash: {},
            getFees: {
                returns: "Amount"
            },
            getInputs: {
                returns: ["BitcoinLikeInput"]
            },
            getOutputs: {
                returns: ["BitcoinLikeOutput"]
            },
            serializeOutputs: {
                returns: "hex"
            },
            getTimestamp: {}
        }
    });
    declare("BitcoinLikeOperation", {
        methods: {
            getTransaction: {
                returns: "BitcoinLikeTransaction"
            }
        }
    });
    declare("BitcoinLikeTransactionBuilder", {
        methods: {
            wipeToAddress: {},
            sendToAddress: {
                params: ["Amount"]
            },
            excludeUtxo: {},
            pickInputs: {},
            setFeesPerByte: {
                params: ["Amount"]
            },
            build: {
                returns: "BitcoinLikeTransaction"
            }
        }
    });
    declare("BitcoinLikeAccount", {
        methods: {
            getUTXO: {
                returns: ["BitcoinLikeOutput"]
            },
            getUTXOCount: {},
            buildTransaction: {
                returns: "BitcoinLikeTransactionBuilder"
            },
            broadcastRawTransaction: {
                params: ["hex"]
            },
            getFees: {
                returns: ["BigInt"]
            }
        }
    });
    declare("BitcoinLikeNetworkParameters", {
        njsUsesPlainObject: true,
        methods: {
            getSigHash: {
                returns: "hex",
                njsField: "SigHash"
            },
            getUsesTimestampedTransaction: {
                njsField: "UsesTimestampedTransaction"
            }
        }
    });
    return {
        OperationMethods: {
            asBitcoinLikeOperation: {
                returns: "BitcoinLikeOperation"
            }
        },
        AccountMethods: {
            asBitcoinLikeAccount: {
                returns: "BitcoinLikeAccount"
            }
        }
    };
};
exports.reflect = reflect;
//# sourceMappingURL=types.js.map